import { computed, makeObservable } from 'mobx';

import { ValueModel } from './ValueModel';

export class ToggleModel extends ValueModel<boolean> {
  constructor(value: boolean = false) {
    super(value);

    makeObservable(this, {
      isOpen: computed,
    });
  }
  get isOpen() {
    return this.value;
  }

  toggle = () => {
    this.change(!this.value);
  };

  close = () => {
    this.change(false);
  };

  open = () => {
    this.change(true);
  };
}
